import { PlusIcon as PlusIconLucide } from "lucide-react";
import { MinusIcon as MinusIconLucide } from "lucide-react";

export const PaddingTopIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M5.72925 5.5H21.7709" stroke={color} strokeLinecap="round" />
      <rect
        x="9.16675"
        y="9.5"
        width="9.16667"
        height="6"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingBottomIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width={20}
      height={20}
      viewBox="0 0 27 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M20.9792 19L5.52092 19" stroke={color} strokeLinecap="round" />
      <rect
        x="17.6667"
        y="15"
        width="8.83333"
        height="6"
        transform="rotate(-180 17.6667 15)"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingLeftIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path
        d="M5.72909 19.5L5.72909 5.5"
        stroke={color}
        strokeLinecap="round"
      />
      <rect
        x="10.3125"
        y="16.5"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16.5)"
        stroke={color}
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const PaddingRightIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <rect
        x="10.3125"
        y="16"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16)"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M21.7708 19V5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PaddingHorizontalIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path
        d="M5.72909 19.5L5.72909 5.5"
        stroke={color}
        strokeLinecap="round"
      />
      <rect
        x="10.3125"
        y="16.5"
        width="8"
        height="6.875"
        transform="rotate(-90 10.3125 16.5)"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M21.7708 19.5V5.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PaddingVerticalIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 28 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width={20}
      height={20}
      {...props}
    >
      <path d="M5.72925 5.5H21.7709" stroke={color} strokeLinecap="round" />
      <rect
        x="9.16675"
        y="9.5"
        width="9.16667"
        height="6"
        stroke={color}
        strokeLinejoin="round"
      />
      <path d="M5.72925 19.5H21.7709" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const WrapIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.125 6.75L3 9.875M3 9.875L6.125 13M3 9.875H9.5625C10.0139 9.875 10.4609 9.78609 10.878 9.61334C11.295 9.44058 11.674 9.18738 11.9932 8.86818C12.3124 8.54898 12.5656 8.17003 12.7383 7.75297C12.9111 7.33592 13 6.88892 13 6.4375C13 5.98608 12.9111 5.53908 12.7383 5.12202C12.5656 4.70497 12.3124 4.32602 11.9932 4.00682C11.674 3.68762 11.295 3.43441 10.878 3.26166C10.4609 3.08891 10.0139 3 9.5625 3H7.375"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const NoWrapIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.79169 6.75L3.66669 9.875M3.66669 9.875L6.79169 13M3.66669 9.875H10.2292C10.6806 9.875 11.1276 9.78609 11.5447 9.61334C11.9617 9.44058 12.3407 9.18738 12.6599 8.86818C12.9791 8.54898 13.2323 8.17003 13.405 7.75297C13.5778 7.33592 13.6667 6.88892 13.6667 6.4375C13.6667 5.98608 13.5778 5.53908 13.405 5.12202C13.2323 4.70497 12.9791 4.32602 12.6599 4.00682C12.3407 3.68762 11.9617 3.43441 11.5447 3.26166C11.1276 3.08891 10.6806 3 10.2292 3H8.04169"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M3.66669 13C4.21669 12.45 11.2292 5.4375 14.6667 2"
        stroke={color}
      />
    </svg>
  );
};

export const WrapReverseIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M5.66673 2L3.00006 4.66667M3.00006 4.66667L5.66673 7.33333M3.00006 4.66667H13.6667M11.0001 14L13.6667 11.3333M13.6667 11.3333L11.0001 8.66667M13.6667 11.3333L3.00006 11.3333"
        stroke={color}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const AlignContentFlexStartIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.16669"
        y="4"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 8.16669 4)"
        fill={color}
      />
      <rect
        x="8.16669"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 8.16669 9)"
        fill={color}
      />
      <rect
        x="13.1667"
        y="4"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 13.1667 4)"
        fill={color}
      />
      <rect
        x="13.1667"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 13.1667 9)"
        fill={color}
      />
      <path d="M2.66669 2.5L14.6667 2.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentFlexEndIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.83337"
        y="11.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 11.5)"
        fill={color}
      />
      <rect
        x="8.83337"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 6.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="11.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 11.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 6.5)"
        fill={color}
      />
      <path d="M14.3334 13L2.33337 13" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentStretchIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="9.16669"
        y="13.5"
        width="5.00137"
        height="4"
        rx="1"
        transform="rotate(-90 9.16669 13.5)"
        fill={color}
      />
      <rect
        x="9.16669"
        y="7.50098"
        width="5.00101"
        height="4"
        rx="1"
        transform="rotate(-90 9.16669 7.50098)"
        fill={color}
      />
      <rect
        x="4.16669"
        y="13.5"
        width="5.00137"
        height="4"
        rx="1"
        transform="rotate(-90 4.16669 13.5)"
        fill={color}
      />
      <rect
        x="4.16669"
        y="7.50098"
        width="5.00101"
        height="4"
        rx="1"
        transform="rotate(-90 4.16669 7.50098)"
        fill={color}
      />
      <path d="M14.6667 15L2.66669 15" stroke={color} strokeLinecap="round" />
      <path
        d="M14.6667 1L2.66669 0.999999"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const AlignContentCenterIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="7.5"
        y="3"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 7.5 3)"
        fill={color}
      />
      <rect
        x="7.5"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 7.5 9)"
        fill={color}
      />
      <rect
        x="12.5"
        y="3"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 12.5 3)"
        fill={color}
      />
      <rect
        x="12.5"
        y="9"
        width="4"
        height="4"
        rx="1"
        transform="rotate(90 12.5 9)"
        fill={color}
      />
      <path d="M2 8L14 8" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentSpaceBetweenIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.5"
        y="13.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.5 13.5)"
        fill={color}
      />
      <rect
        x="8.5"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.5 6.5)"
        fill={color}
      />
      <rect
        x="3.5"
        y="13.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.5 13.5)"
        fill={color}
      />
      <rect
        x="3.5"
        y="6.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.5 6.5)"
        fill={color}
      />
      <path d="M14 15L2 15" stroke={color} strokeLinecap="round" />
      <path d="M14 1L2 0.999999" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignContentSpaceAroundIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="17"
      height="16"
      viewBox="0 0 17 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="8.83337"
        y="12.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 12.5)"
        fill={color}
      />
      <rect
        x="8.83337"
        y="7.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 8.83337 7.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="12.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 12.5)"
        fill={color}
      />
      <rect
        x="3.83337"
        y="7.5"
        width="4"
        height="4"
        rx="1"
        transform="rotate(-90 3.83337 7.5)"
        fill={color}
      />
      <path d="M14.3334 15L2.33337 15" stroke={color} strokeLinecap="round" />
      <path
        d="M14.3334 1L2.33337 0.999999"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const JustifySpaceBetweenIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="13"
        y="3"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 3)"
        fill={color}
      />
      <rect
        x="13"
        y="10"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 10)"
        fill={color}
      />
      <path d="M14 15L2 15" stroke={color} strokeLinecap="round" />
      <path d="M14 1L2 1" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyFlexEndIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4"
        y="10.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 10.5)"
        fill={color}
      />
      <rect
        x="4"
        y="6.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 6.5)"
        fill={color}
      />
      <path d="M14 12.5L2 12.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyFlexStartIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="12"
        y="5.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 5.5)"
        fill={color}
      />
      <rect
        x="12"
        y="9.5"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 9.5)"
        fill={color}
      />
      <path d="M2 3.5L14 3.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifySpaceEvenlyIcon = ({
  color = "currentColor",
  ...props
}) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="3"
        y="12"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 3 12)"
        fill={color}
      />
      <rect
        x="3"
        y="7"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 3 7)"
        fill={color}
      />
      <path d="M2 2L14 2" stroke={color} strokeLinecap="round" />
      <path d="M2 14L14 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const JustifyCenterIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="12"
        y="3"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 3)"
        fill={color}
      />
      <rect
        x="12"
        y="10"
        width="3"
        height="8"
        rx="1"
        transform="rotate(90 12 10)"
        fill={color}
      />
      <path d="M2 8L14 8" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsCenterIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="13"
        y="4"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 13 4)"
        fill={color}
      />
      <rect
        x="11"
        y="9"
        width="3"
        height="6"
        rx="1"
        transform="rotate(90 11 9)"
        fill={color}
      />
      <path d="M8 2L8 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsEndIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="2"
        y="7"
        width="3"
        height="10"
        rx="1"
        transform="rotate(-90 2 7)"
        fill={color}
      />
      <rect
        x="5"
        y="12"
        width="3"
        height="7"
        rx="1"
        transform="rotate(-90 5 12)"
        fill={color}
      />
      <path d="M14 14L14 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsStartIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="14"
        y="4"
        width="3"
        height="10"
        rx="1"
        transform="rotate(90 14 4)"
        fill={color}
      />
      <rect
        x="11"
        y="9"
        width="3"
        height="7"
        rx="1"
        transform="rotate(90 11 9)"
        fill={color}
      />
      <path d="M2 2L2 14" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsStretchIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <rect
        x="4"
        y="12"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 12)"
        fill={color}
      />
      <rect
        x="4"
        y="7"
        width="3"
        height="8"
        rx="1"
        transform="rotate(-90 4 7)"
        fill={color}
      />
      <path d="M2 14L2 2" stroke={color} strokeLinecap="round" />
      <path d="M14 14L14 2" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const AlignItemsBaseline = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 3.5L8.5 6.5L3.5 6.5C2.94772 6.5 2.5 6.05228 2.5 5.5L2.5 4.5C2.5 3.94772 2.94772 3.5 3.5 3.5L8.5 3.5Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M8.5 3.5L8.5 6.5L12.5 6.5C13.0523 6.5 13.5 6.05228 13.5 5.5L13.5 4.5C13.5 3.94771 13.0523 3.5 12.5 3.5L8.5 3.5Z"
        fill={color}
      />
      <path
        d="M8.5 8.5L8.5 11.5L3.5 11.5C2.94772 11.5 2.5 11.0523 2.5 10.5L2.5 9.5C2.5 8.94772 2.94772 8.5 3.5 8.5L8.5 8.5Z"
        fill={color}
      />
      <path
        opacity="0.5"
        d="M8.5 8.5L8.5 11.5L10.5 11.5C11.0523 11.5 11.5 11.0523 11.5 10.5L11.5 9.5C11.5 8.94771 11.0523 8.5 10.5 8.5L8.5 8.5Z"
        fill={color}
      />
      <path d="M8.5 1.5L8.5 13.5" stroke={color} strokeLinecap="round" />
    </svg>
  );
};

export const PlusIcon = ({ color = "currentColor", ...props }) => {
  return (
    <PlusIconLucide
      color={color}
      strokeWidth={"0.5px"}
      width={18}
      height={18}
      {...props}
    />
  );
};

export const MinusIcon = ({ color = "currentColor", ...props }) => {
  return (
    <MinusIconLucide
      color={color}
      strokeWidth={"0.5px"}
      width={18}
      height={18}
      {...props}
    />
  );
};

export const ExpandSettingPadding = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M1.97909 6.33325V12.6666" stroke={color} strokeLinecap="round" />
      <path d="M17.0208 6.33325V12.6666" stroke={color} strokeLinecap="round" />
      <path d="M12.6667 16.625H6.33341" stroke={color} strokeLinecap="round" />
      <path
        d="M12.6667 2.375L6.33341 2.375"
        stroke={color}
        strokeLinecap="round"
      />
    </svg>
  );
};

export const PlanOfActionIcon = ({ color = "currentColor", ...props }) => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      stroke-width="2"
      stroke-linecap="round"
      stroke-linejoin="round"
    >
      <path d="M16 12H3" />
      <path d="M16 18H3" />
      <path d="M16 6H3" />
      <path d="M21 12h.01" />
      <path d="M21 18h.01" />
      <path d="M21 6h.01" />
    </svg>
  );
};
